/* stylelint-disable max-nesting-depth, selector-max-compound-selectors */
.service-calls-overview {
    &__result-set {
        position: relative;

        @include legacy-gridle-state(large) {
            text-align: center;
        }

        @include legacy-gridle-state(mtd) {
            text-align: left;
        }
    }

    &__table-container.service-calls-overview__table-container {
        @media (max-width: 567px) {
            padding-top: 10px !important;
        }
    }

    .ux-text-status ux-icon {
        font-size: 18px;
        transform: translateY(2px);

        + ux-icon {
            display: none;
        }
    }

    .ux-filter {
        .ux-tag {
            * {
                pointer-events: none;
            }
        }
    }

    .ux-table {
        table {
            width: 100%;
        }

        th {
            max-width: none !important;
        }

        tr > td:first-child {
            @include font(light);
        }
    }

    &__filter-container {
        .row + .row {
            margin-top: 30px;
        }
    }

    &__filter-dropdown {
        min-width: 250px;
        position: relative;
        margin-bottom: 10px;

        @media only screen and (min-width: 768px) {
            max-width: 300px;
            display: inline-block;
            margin-right: 18px;
        }
    }

    .filter-flex {
        @media (min-width: 1025px) {
            display: flex;

            > div + div {
                margin-left: 20px;
            }
        }

        > div {
            width: 100%;
            margin-bottom: 10px;

            @media (min-width: 1025px) {
                width: 20%;
            }
        }

        .ux-dropdown__label {
            ux-icon {
                margin-left: 20px;
                transform: translateY(-1px);
            }
        }
    }
}

/* stylelint-enable max-nesting-depth, selector-max-compound-selectors */
